meedy.controller('meedy.toastCalendarCyclicTermModeController', ['$scope', '$state', '$mdToast',
    function ($scope, $state, $mdToast) {

        function setData() {
            // isolated scope, needs these injected again
            $scope.Enum = Enum;
            $scope.Constant = Constant;

            $scope.cyclicMode = Enum.MEEDY.CYCLIC_TERM_UPDATE_TYPE.THIS;
        }

        function setPermissions() {
        }

        function setListeners() {
        }

        function setActions() {
            $scope.ok = function() {
                $mdToast.hide($scope.cyclicMode);
            };

            $scope.cancel = function() {
                $mdToast.cancel();
            };
        }

        function configureInterface() {

        }

        function initialize() {
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);